import { useEffect, useState } from "react";

type WakeLockSentinelLike = { release: () => Promise<void> };

type Nav = Navigator & {
  wakeLock?: { request: (kind: "screen") => Promise<WakeLockSentinelLike> };
};

export function useWakeLock(active: boolean): { supported: boolean } {
  const [supported, setSupported] = useState(false);

  useEffect(() => {
    const nav = navigator as Nav;
    setSupported(typeof nav.wakeLock?.request === "function");
  }, []);

  useEffect(() => {
    if (!active) return;
    let sentinel: WakeLockSentinelLike | null = null;
    let cancelled = false;

    const acquire = async () => {
      const nav = navigator as Nav;
      if (!nav.wakeLock) return;
      try {
        sentinel = await nav.wakeLock.request("screen");
      } catch {
        /* user gesture may be required */
      }
    };

    acquire();

    const onVis = () => {
      if (document.visibilityState === "visible") acquire();
    };
    document.addEventListener("visibilitychange", onVis);

    return () => {
      cancelled = true;
      document.removeEventListener("visibilitychange", onVis);
      if (sentinel && !cancelled) sentinel.release().catch(() => undefined);
    };
  }, [active]);

  return { supported };
}
